import { render, staticRenderFns } from "./ActivationInsight.vue?vue&type=template&id=dcffc760&scoped=true"
import script from "./ActivationInsight.vue?vue&type=script&lang=js"
export * from "./ActivationInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcffc760",
  null
  
)

export default component.exports